import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import moment from "moment";
import { renderSingleCheckbox, renderHiddenFieldText } from "@basecomponent";
import {
  convertUTCDateIntoLocalDate,
  displayDateInBrowserFormat,
} from "@datehandle";
import LocaleStrings from "@language";

const SessionRSVP = (props) => {
  let {
    // Parent
    // source = "",
    ticketSessionSettings = {}, // Ticket specific session settings for RSVP
    formValues,
    RSVPSessionsData,
    eventSettingsData,

    // Own
    eventData,
  } = props;
  let showGlobalTime = eventData?.showconvertedtimezone ?? false; // true/flase, check if global timezone is enabled, then display local time, else time as per event
  let multipleRSVP = eventSettingsData?.rsvpmultiple ?? true; // true/false, check the multiple RSVP allowed of common time sessions
  let restrictRSVPPerTrack = JSON.parse(
    eventSettingsData?.session_settings ?? "{}"
  )?.single_rsvp_per_track; // true/false , check the restrict attendees to mark rsvp more than one sessions per track
  let rsvpsessions = formValues?.rsvpsessions ?? [];
  let allowRSVP = ticketSessionSettings?.allowrsvp ?? true; // Session RSVP restriction
  let maxSessionRSVP = ticketSessionSettings?.maxsessionrsvp ?? ""; // Session RSVP max limit

  // console.log("source :- ", source);
  // console.log("formValues :- ", formValues);
  // console.log("RSVPSessionsData :- ", RSVPSessionsData);

  const handleRSVPSession = (id) => {
    if (rsvpsessions?.length > 0) {
      let index = rsvpsessions.indexOf(id);
      if (index > -1) {
        rsvpsessions.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        rsvpsessions.push(id);
      }
    } else {
      rsvpsessions.push(id);
    }

    props.autofill("rsvpsessions", rsvpsessions);
    if (typeof props?.onChange === "function") {
      props?.onChange(); // this will work only while ticket purchase pre assigned attendee
    }
  };

  const checkOverlapping = (stime, etime, trackname) => {
    let mutiplersvp = false;
    let multiplepertrack = false;
    let revpSessions = [];
    RSVPSessionsData?.forEach((obj) => {
      let sessionid = obj?.sessionid;
      let index = rsvpsessions.indexOf(sessionid);
      if (index > -1) {
        revpSessions.push(obj);
      }
    });
    if (!multipleRSVP) {
      let match = revpSessions.filter((obj) => {
        return (
          (moment(stime).unix() >= moment(obj?.starttime).unix() &&
            moment(stime).unix() < moment(obj?.endtime).unix()) ||
          (moment(etime).unix() > moment(obj?.starttime).unix() &&
            moment(etime).unix() <= moment(obj?.endtime).unix()) ||
          (moment(stime).unix() < moment(obj?.starttime).unix() &&
            moment(etime).unix() > moment(obj?.endtime).unix())
        );
      });

      mutiplersvp = match?.length > 0;
    }
    if (restrictRSVPPerTrack) {
      let match = revpSessions.filter((obj) => {
        return (
          trackname?.trim()?.toLowerCase() ===
          obj?.trackname?.trim()?.toLowerCase()
        );
      });
      multiplepertrack = match?.length > 0;
    }
    return mutiplersvp || multiplepertrack;
  };

  let lastDisplayedDate = "";

  return (
    <>
      <Field
        name="rsvpsessionserror"
        component={renderHiddenFieldText}
        type="text"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {RSVPSessionsData?.map((obj, i) => {
          let sessionid = obj?.sessionid;
          let capacity = obj?.capacity;
          let totalRSVP = obj?.totalrsvpcount;
          let stime = moment(obj?.starttime);
          let etime = moment(obj?.endtime);
          let priColor = obj?.primarytextcolor
            ? obj?.primarytextcolor.trim()
            : "";
          let secColor = obj?.secondarytextcolor
            ? obj?.secondarytextcolor.trim()
            : "";
          let bgColor = obj?.backgroundcolor ? obj?.backgroundcolor.trim() : "";
          let borderColor = obj?.bordercolor ? obj?.bordercolor.trim() : "";
          let track = obj.trackname;
          let currentDate = obj.scheduledate;

          let disabled = false;
          let seatFull = "";
          if (!allowRSVP) {
            disabled = true;
          } else {
            if (capacity > 0 && capacity === totalRSVP) {
              disabled = true;
              seatFull = LocaleStrings.kSessionFullText;
            } else {
              let index = rsvpsessions.indexOf(sessionid);
              if (index > -1) {
                disabled = false;
              } else {
                disabled = checkOverlapping(stime, etime, track); // logic to check current session is overlapping with already selected session or not
              }
            }
            // If max session rsvp limit reached for this ticket, then disable other sessions
            if (
              !disabled &&
              maxSessionRSVP !== "" &&
              rsvpsessions.length >= parseInt(maxSessionRSVP)
            ) {
              if (rsvpsessions.includes(sessionid)) {
                disabled = false;
              } else {
                disabled = true;
              }
            }
          }
          let sessionTime = `${displayDateInBrowserFormat(
            obj?.starttime,
            "Pp"
          )} - ${displayDateInBrowserFormat(obj?.endtime, "p")}`;
          if (showGlobalTime) {
            sessionTime = `${convertUTCDateIntoLocalDate(
              obj?.starttime_gmt,
              "Pp"
            )} - ${convertUTCDateIntoLocalDate(obj?.endtime_gmt, "p")}`;
          }
          const dateJSX =
            lastDisplayedDate !== currentDate ? (
              <div
                key={`key_session_date_${i}`}
                className="custom-text-primary-lg-bold col-span-full"
              >
                {moment(currentDate).format("MMMM DD, YYYY")}
              </div>
            ) : (
              ""
            );

          lastDisplayedDate = currentDate;

          return (
            <>
              {dateJSX}
              <div
                key={`key_session_${i}`}
                className="border border-default bg-white p-4 rounded-lg relative"
                style={{
                  backgroundColor: bgColor,
                  borderColor: borderColor,
                }}
              >
                <Field
                  name={`markrsvp[${i}]`}
                  htmllabel={`<div class="space-y-0.5">
                  <div class="custom-text-primary-md-normal pr-5" style="color:${priColor}">${
                    obj?.title
                  } ${
                    seatFull !== ""
                      ? `<span class="custom-text-theme-sm-bold ml-1" style="color:${priColor}">(${seatFull})</span>`
                      : ""
                  }</div>
                  <div class="custom-text-secondary-sm-medium">${
                    obj?.trackname && obj?.trackname !== "##NOTRACK##"
                      ? obj?.trackname
                      : ""
                  }</div>
                  ${
                    obj?.location
                      ? `<div class="custom-text-secondary-sm-normal custom-item-vcenter gap-1" style="color:${secColor}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                    </svg>
                    ${obj?.location}
                  </div>`
                      : ``
                  }
                  <div class="custom-text-secondary-sm-normal custom-item-vcenter gap-1" style="color:${secColor}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    ${sessionTime}
                  </div>
                </div>`}
                  component={renderSingleCheckbox}
                  value={sessionid}
                  onChange={() => handleRSVPSession(sessionid)}
                  type="checkbox"
                  disabled={disabled}
                />
                {obj?.description && (
                  <>
                    <div className="group inline-block absolute top-1 right-1">
                      <div className="text-gray-500 cursor-pointer absolute- top-1 right-1">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.05998 5.99967C6.21672 5.55412 6.52608 5.17841 6.93328 4.9391C7.34048 4.69978 7.81924 4.6123 8.28476 4.69215C8.75028 4.772 9.17252 5.01402 9.4767 5.37536C9.78087 5.7367 9.94735 6.19402 9.94665 6.66634C9.94665 7.99967 7.94665 8.66634 7.94665 8.66634M7.99998 11.333H8.00665M14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663C4.31808 14.6663 1.33331 11.6816 1.33331 7.99967C1.33331 4.31778 4.31808 1.33301 7.99998 1.33301C11.6819 1.33301 14.6666 4.31778 14.6666 7.99967Z"
                            stroke={secColor}
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>

                      <div className="absolute   bottom-4 -left-64 mb-3 hidden group-hover:block w-[34rem] bg-white text-gray-700 text-base p-4 rounded-xl shadow-lg">
                        <div className="max-h-40 overflow-auto">
                          {" "}
                          {obj?.description}
                        </div>

                        {/* Tooltip arrow */}

                        <div className="absolute right-1/2 top-[97%] w-3 h-3 bg-white rotate-45 shadow-lg z-0">
                          <div className="opacity-0 w-10 h-10"></div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return { eventData: state.eventData };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SessionRSVP);
